// removed by extract-text-webpack-plugin
module.exports = {"content":"CustomFormList__content__15iBq","parentContainer":"CustomFormList__parentContainer__2hVAQ","nameCustomFormWrapper":"CustomFormList__nameCustomFormWrapper__1azCS","table":"CustomFormList__table__2JipS","actions":"CustomFormList__actions__2zl0O","name":"CustomFormList__name__3wdVB","iconEdit":"CustomFormList__iconEdit__1736n","reactivateBtn":"CustomFormList__reactivateBtn__10sy1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CustomFormList/CustomFormList.css
// module id = 3068
// module chunks = 0